<template>
  <v-card>
    <v-card-subtitle>
      Delete by cells numbers
    </v-card-subtitle>
    <v-card-text>
      <v-form
        ref="numbersForm"
        v-model="numberFormValid"
        lazy-validation
      >
        <v-textarea
          filled
          placeholder="Cell Numbers to be delete"
          v-model="cells"
          :rules="[$validation.required]"
          rows="15"
        ></v-textarea>
        <v-btn color="primary" :loading="updating" @click="submitNumbers">Delete cells by numbers</v-btn>

      </v-form>
    </v-card-text>
    <!-- <v-card-subtitle>
      Delete by Power Range
    </v-card-subtitle> -->
    <!-- <v-card-text>
      <v-form
        ref="rangeForm"
        v-model="rangeFormValid"
        lazy-validation
      >
        <v-row align="end">
          <v-col md="3">
            <v-text-field
              outlined
              label="Startig Power"
              v-model="powerRange.start"
              hide-details
              type="number"
              :rules="[$validation.required]"
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <v-text-field
              outlined
              label="End Power"
              v-model="powerRange.end"
              hide-details
              type="number"
              :rules="[$validation.required]"
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <v-btn color="primary" @click="submitRange">Delete cells by range</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text> -->
  </v-card>
</template>

<script>
import api from "@/api"
export default {
  data: () => ({
    cells: "",
    powerRange: {
      start: "",
      end: ""
    },
    numberFormValid: true,
    rangeFormValid: true,
    updating: false
  }),
  methods: {
    async submitNumbers() {
      this.updating = true;
      if (!this.$refs.numbersForm.validate()) return;
      try {
        const cells = this.cells.match(/\d+/g);
        const response = await api.deleteCells(cells);
        this.$toast.success({ title: response.data })
      } catch (error) {
        this.$toast.error({ title: "Error Deleting try again" })
      }
      this.updating = false;
    },
    // async submitRange() {
    //   if (!this.$refs.rangeForm.validate()) return;
    //   await api.deleteCells({ range: this.powerRange})
    // }
  }
}
</script>